import { Icon, MaskedLink } from '@hz-design-system/web-ui';
import React from 'react';
import Classes from '../ProfileSidebar.scss';

const WebsiteUrl = ({ url }: { url: string }) => {
  const href = /^https?:\/\/|^\/\//i.test(url) ? url : `https://${url}`;

  let parsed: URL;
  try {
    parsed = new URL(href);
  } catch {
    return null;
  }

  return (
    <li className={Classes.infoWrap}>
      <Icon name="website" />
      <MaskedLink href={parsed.href} className={Classes['infoWrap-link']} target="_blank" rel="noopener noreferrer">
        {url}
      </MaskedLink>
    </li>
  );
};

export default WebsiteUrl;
